import {getI18n, useTranslation} from "react-i18next";
import ls from "../../../../utils/ls";
import {useEffect, useMemo} from "react";
import Button from "../../../Button";
import {calc} from "../../../../utils";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import Buffer from "../../../Buffer";

export default function CartMenus({ children, goodsList,shopGoodsList }) {
  const navigateTo = useNavigateTo();
  const lang = getI18n().language;
  const checkout = () => {
    let checkedShop = [...shopGoodsList].map((shop) => {
      let res = { ...shop };
      
      if (res.goodsList.length > 0) {
        res.goodsList = res.goodsList.map((goods) => {
          return {
            itemId: goods.itemId,
            itemSkuId: goods.itemSkuId,
            mainPicView: goods.mainPic,
            preferPrice: goods.preferPrice || 0,
            price: goods.price,
            productName: goods.itemName,
            productEnName: goods.itemEnName,
            quantity: goods.quantity,
            shopcarDetailId: goods.shopcarDetailId,
            specName: goods.specName
          };
        });
      }
      return res;
    });
    
    ls.setConfirmGoodsList(checkedShop);
    navigateTo('/confirmOrder');
  };
  
  const totalAmount = useMemo(() => {
    let res = 0;
    goodsList.forEach((item) => {
      res += item.price * item.quantity;
    });
    return calc.add(res);
  }, [goodsList]);
  
  return (
    children ? children({
        checkout, totalAmount, navigateTo
      })
      : null
  );
}
